module.exports = __webpack_public_path__ + "static/media/kdr.5315ac8e.png";